import styled from 'styled-components';

export const Container = styled.div`
  border-radius: 12px;
  padding: 16px 20px;
  background: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
  max-height: 480px;
  display: flex;
  flex-direction: column;
  gap: 12px;

  .menu-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.5rem;

    h3 {
      text-transform: capitalize;
      font-size: 1rem;
      font-weight: bold;
      color: #333;
    }

    button {
      border: none;
      background-color: #4f46e5;
      transition: background 0.3s ease;
      color: white;
      padding: 6px 14px;
      border-radius: 6px;
      font-weight: bold;
      font-size: 0.85rem;
      cursor: pointer;

      :hover {
        background-color: #4338ca;
      }
    }
  }

  .wrapper {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .details {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 12px;
    border-radius: 8px;
    background: #f9fafb;
    transition: all 0.2s ease;
    cursor: pointer;

    &:hover {
      background: #eef2ff;
      transform: translateY(-2px);
      box-shadow: 0 4px 8px rgba(79, 70, 229, 0.1);
    }

    .left {
      display: flex;
      align-items: center;
      gap: 8px;
      color: #4b5563;
    }

    .description {
      font-size: 0.85rem;
      font-weight: 600;
      text-transform: uppercase;
    }

    .balance {
      font-size: 1rem;
      font-weight: bold;
    }

    .amount-red {
      color: #dc2626;
    }

    .amount-green {
      color: #16a34a;
    }

    .amount-neutral {
      color: #6b7280;
    }
  }
`;
